import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getEnableOperatorVerification = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.enableOperatorVerification ?? false;
  }
);
